import * as runtime from '@/api/runtime'
import {
  SystemCheckError,
  SystemCheckErrorFromJSON,
  SystemCheckRequest,
  SystemCheckRequestToJSON
} from '@/api'

export class SystemCheckApi extends runtime.BaseAPI {
  /**
   * システムチェックする
   * システムチェック
   */
  async systemCheck(request: SystemCheckRequest): Promise<SystemCheckError> {
    const bodyParameters: runtime.HTTPBody = SystemCheckRequestToJSON(request)

    const response = await this.requestPost('/system-checks', bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemCheckErrorFromJSON(jsonValue)
    ).value()
  }
}
